module.exports = require("./fr-MC.d.ts");